<template>
	<div class="wl-results" v-if="doc">
		<results-bar
			:doc="doc"
			@loadUser="loadUser"
			@loadSummary="loadSummary"
			:includeAdmin="true"
		></results-bar>
		<results-summary v-if="summary" :id="doc.id" :key="key"></results-summary>
		<results-user
			v-if="!summary"
			:key="key"
			:uid="currentUser"
			:id="doc.id"
		></results-user>
	</div>
</template>

<script>
import {
	ResultsUser,
	ResultsBar,
	ResultsSummary,
} from '@/components/results/priority';

export default {
	name: 'PriorityResults',
	props: {
		doc: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			summary: true,
			summaryMode: 'popular',
			currentUser: null,
			userList: null,
			key: 1,
		};
	},
	components: {
		ResultsUser,
		ResultsBar,
		ResultsSummary,
	},
	methods: {
		loadSummary(mode) {
			this.currentUser = null;
			this.summaryMode = mode;
			this.summary = true;
			this.addKey();
		},
		loadUser(uid) {
			this.currentUser = uid;
			this.summary = false;
			this.addKey();
		},
		addKey() {
			this.key++;
		},
	},
};
</script>
